import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SettingsService } from '../../../core/settings/settings.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-top-navbar',
  templateUrl: './top-navbar.component.html',
  styleUrls: ['./top-navbar.component.scss'],
  imports: [
    CommonModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopNavbarComponent {
  @Input() public title: string;

  public settingsObservable = this.settingsService.getSettingsOnce();

  constructor(private settingsService: SettingsService) {
  }
}
